"use client";

import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";

const Committeescard = ({
    imageSrc,
    imageAlt = "",
    title,
    description,
    slug,
    delay = 0,
}) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
            className="group relative flex h-full flex-col overflow-hidden border border-gray-200/60 bg-white transition-transform duration-500 hover:-translate-y-1 hover:border-orange-200 hover:shadow-2xl hover:shadow-orange-100/30"
        >
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-orange-50/0 to-amber-50/0 transition-colors duration-500 group-hover:from-orange-50/60 group-hover:to-amber-50/40" />

            <div className="relative w-full h-40 sm:h-44 md:h-48 lg:h-52 overflow-hidden">
                <Image
                    src={imageSrc}
                    alt={imageAlt || title}
                    fill
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                    unoptimized
                    // fetchPriority="high"
                    className="object-cover transition-transform duration-500 group-hover:scale-105"
                />
            </div>

            <div className="relative flex flex-1 flex-col space-y-3 sm:space-y-4 md:space-5 px-3 sm:px-4 md:px-5 py-4">
                <h3 className="text-sm sm:text-base md:text-lg lg:text-xl font-saansBold tracking-tight text-gray-900 transition-colors duration-300 group-hover:text-[#FC9D00]">
                    {title}
                </h3>

                <p className="text-xs sm:text-sm md:text-[15px] lg:text-base leading-relaxed text-gray-600 font-saansRegular">
                    {description}
                </p>

                <div className="mt-auto pt-3">
                    <Link
                        href={`/statutory-committees/${slug}`}
                        className="w-full flex justify-center items-center gap-3 bg-[#FFA201] text-white px-6 py-2.5 md:py-3 text-xs sm:text-sm font-semibold transition-colors duration-300 hover:bg-[#FF8800]"
                    >
                        <span>Learn More</span>
                        <span className="cursor-pointer rotate-45 material-symbols-outlined text-lg">
                            north_east
                        </span>
                    </Link>
                </div>
            </div>

            <div className="absolute -top-10 -right-10 h-24 w-24 sm:h-28 sm:w-28 md:h-32 md:w-32 bg-gradient-to-br from-orange-200 to-amber-200 opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-60" />
            <div className="absolute bottom-0 left-0 right-0 h-0.5 sm:h-1 origin-left scale-x-0 bg-gradient-to-r from-[#FC9D00] to-[#FF8800] transition-transform duration-500 group-hover:scale-x-100" />
        </motion.div>
    );
};

export default Committeescard;
